/** The lockup travels from its stack to the chrome strip over 90px of scroll. */
export function collapseProgress(scrollTop: number): number {
  return Math.min(1, Math.max(0, scrollTop / 90));
}

type Rect = Pick<DOMRectReadOnly, 'left' | 'top' | 'width' | 'height'>;

export interface LockupMove {
  dx: number;
  dy: number;
  s: number;
}

export function computeMove(fromRect: Rect, toRect: Rect): LockupMove {
  return {
    dx: toRect.left + toRect.width / 2 - (fromRect.left + fromRect.width / 2),
    dy: toRect.top + toRect.height / 2 - (fromRect.top + fromRect.height / 2),
    // Width tracks the glyph run; line-height makes text heights unreliable.
    s: fromRect.width > 0 ? toRect.width / fromRect.width : 1,
  };
}

export function applyProgress(move: LockupMove, p: number): string {
  // An identity transform still creates a containing/compositing layer in WKWebView.
  if (p === 0) return '';
  return `translate(${move.dx * p}px, ${move.dy * p}px) scale(${1 + (move.s - 1) * p})`;
}

/** The descriptor line fades and lifts during the collapse instead of travelling (mockup). */
export function applyFade(p: number): { opacity: string; transform: string } {
  if (p === 0) return { opacity: '', transform: '' };
  return { opacity: String(Math.max(0, 1 - p * 1.6)), transform: `translateY(${-6 * p}px)` };
}
